const map = {
	"./1.jpg": 1805,
	"./10.jpg": 1985,
	"./11.jpg": 3940,
	"./12.jpg": 5571,
	"./13.jpg": 2406,
	"./2.jpg": 9522,
	"./3.jpg": 7583,
	"./4.png": 3600,
	"./5.jpg": 4129,
	"./6.jpg": 6374,
	"./7.jpg": 5859,
	"./8.jpg": 1400,
	"./9.jpg": 9269
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6696;